import { PoSystemStatusTypeNameValueEnum } from '../enum/po-system-status.enum';
import { BaseDto } from './base.dto';

export class PoSystemStatusCountResultDto extends BaseDto {
  type: PoSystemStatusTypeNameValueEnum;
  count: number;
}
